import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../../cra/src/styling/breakpointsMinWidth';
import BlogLink from './links/getBlogLink';
import { DarkRed } from '../../../../../../../../../cra/src/styling/theme';
import getFormattedDateblog from '../../../../../../utils/getFormattedDateblog';

const BlogCardsSection = styled.section`
  margin: 28px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 12px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 28px 0;

    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 24px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: repeat(12, 1fr);
  }
`;

const BlogCardsWrap = styled.div`
  grid-column: 1/-1;

  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 24px;

  & a,
  & a:hover {
    color: unset;
    text-decoration: none;
  }

  @media ${breakpointsMinWidth.mobileLg} {
    grid-row-gap: 28px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/-2;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    grid-column-gap: 28px;

    grid-template-columns: repeat(3, 1fr);
  }

  @media ${breakpointsMinWidth.desktopMini} {
    grid-row-gap: 36px;
    grid-column-gap: 36px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    grid-row-gap: 48px;
    grid-column-gap: 48px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    grid-template-columns: repeat(4, 1fr);
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 3/-3;
  }
`;

const BlogCard = styled.article`
  position: relative;

  background: #fff;

  box-shadow: 0px 0px 18px rgba(41, 49, 89, 0.24);

  cursor: pointer;

  @media ${breakpointsMinWidth.tabletSm} {
    display: grid;
    grid-template-columns: 0.5fr 1fr;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    display: grid;
    grid-template-columns: 0.4fr 1fr;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    display: block;
  }
`;

const ContentWrap = styled.div`
  padding: 24px;

  @media ${breakpointsMinWidth.tabletMd} {
    padding: 28px;
  }
`;

const Heading = styled.h6`
  color: #333d47;

  line-height: 24px;
`;

const SummaryDiv = styled.div`
  font-size: 12px;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  box-orient: vertical;
  -webkit-line-clamp: 3;
  -moz-line-clamp: 3;
  -ms-line-clamp: 3;
  line-clamp: 3;
`;

const Image = styled.img`
  width: 100%;
`;

const BlogThumbnail = styled(Image)`
  @media ${breakpointsMinWidth.tabletSm} {
    height: 100%;
    object-fit: cover;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    height: 220px;
  }
`;

const AuthorWrap = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 12px;
`;

const AuthorPicture = styled(Image)`
  border-radius: 50%;

  width: 36px;
  height: 36px;
`;

const AuthorInfo = styled.div``;

const Name = styled.div`
  color: #333d47;

  font-weight: 500;
`;

const TimePost = styled.div`
  font-size: 12px;
`;

const CardFooter = styled.div`
  padding: 16px 0 0 0;
  border-top: 1px solid #e0e0e0;

  @media ${breakpointsMinWidth.tabletSm} {
    display: grid;
    grid-template-columns: 1fr auto;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    display: block;
  }
`;

const CategoryBtn = styled.div`
  position: absolute;
  right: 18px;
  top: 18px;

  color: #fff;
  background: #473880;

  width: max-content;

  padding: 8px 16px;

  border-radius: 4px;

  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 12px;
  font-weight: 500;

  cursor: pointer;

  @media ${breakpointsMinWidth.tabletSm} {
    position: static;

    align-self: center;
    justify-self: right;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    position: absolute;
  }
`;

const TextWrapper = styled.div`
  grid-column: 1/-1;
  /* width: 630px; */
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  /* margin: 0 auto; */
`;

const Separator = styled.hr`
  flex: 1 0 0%;
`;
const Text = styled.span`
  color: rgba(14, 19, 24, 0.7);
  font-size: 16px;
  font-weight: bold;
  color: #333d47;
  letter-spacing: 0.12em;
  margin: 0px 8px;
`;

const DescriptionWrapper = styled.div`
  height: 112px;
  overflow: hidden;
  display: inline-block;
  word-break: break-word;
`;
const NoSectionWrapper = styled.div`
  display: flex;
  color: ${DarkRed};
  padding: 10px 24px;
  height: 2.5rem;
  font-size: 14px;
`;

const BlogCards = ({
  blogs,
  activeCategory,
  changeCategory,
  isBlogPage,
  blogGalleryData,
  searchedValue,
}) => {
  const blogData = blogs || blogGalleryData.map(({ node }) => node);
  const filteredBlogData = blogData.filter((blog) => {
    if (!searchedValue && activeCategory === 'all') {
      return blog;
    }
    return searchedValue
      ? blog.title.toLowerCase().includes(searchedValue)
      : blog.categoryType === activeCategory;
  });

  return (
    // const BlogCards = ({ blogs: blog, activeCategory, changeCategory, isBlogPage }) => (
    <BlogCardsSection>
      <BlogCardsWrap>
        {isBlogPage && (
          <TextWrapper>
            <Separator />
            <Text>SIMILAR ARTICLES</Text>
            <Separator />
          </TextWrapper>
        )}
        {filteredBlogData.length ? (
          filteredBlogData.map((blog) => {
            const formattedDate = getFormattedDateblog(blog.created);

            return (
              <BlogLink
                key={`blog-${blog.created}`}
                link={blog.blogUrl}
                isBlogPage={isBlogPage}
              >
                <BlogCard>
                  <BlogThumbnail
                    src={blog.blogImg && blog.blogImg.url}
                    alt={blog.slug}
                  />

                  <ContentWrap>
                    <DescriptionWrapper>
                      <Heading>{blog.title}</Heading>
                      <SummaryDiv>{blog.summary}</SummaryDiv>
                    </DescriptionWrapper>
                    <CardFooter>
                      <AuthorWrap>
                        <AuthorPicture
                          src={blog.profileIMG && blog.profileIMG.url}
                          alt={blog.author}
                        />
                        <AuthorInfo>
                          <Name>{blog.author}</Name>
                          <TimePost>
                            {formattedDate} • {blog.readTime} min read
                          </TimePost>
                        </AuthorInfo>
                      </AuthorWrap>

                      <CategoryBtn
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          changeCategory(blog.categoryType);
                        }}
                      >
                        {blog.categoryName}
                      </CategoryBtn>
                    </CardFooter>
                  </ContentWrap>
                </BlogCard>
              </BlogLink>
            );
          })
        ) : (
          <NoSectionWrapper>There is No Such Articles!</NoSectionWrapper>
        )}
      </BlogCardsWrap>
    </BlogCardsSection>
  );
};

export default BlogCards;
